import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CarouselState{
    selectedImageIndex: number
}

const initialState: CarouselState = {
    selectedImageIndex:0
}

const carouselSlice = createSlice({
    name:"carousel",
    initialState,
    reducers:{
        setSelectedImageIndex(state, action:PayloadAction<number>){
            state.selectedImageIndex = action.payload;
        }
    }
});

export const {setSelectedImageIndex} = carouselSlice.actions;

export default carouselSlice.reducer